var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEscogerLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.55,
    height: 31.287,
    viewBox: "0 0 29.55 31.287",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#7827ee;}.a{font-size:12px;font-family:FiraSans-SemiBold, Fira Sans;font-weight:600;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-98.646 -493.356)"
  }, /*#__PURE__*/React.createElement("text", {
    className: "a",
    transform: "translate(121.195 504.84)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -2.856,
    y: 0
  }, "?")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(95.792 493.254)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.854 0.102)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M59.779,7.677A7.575,7.575,0,1,0,52.2,15.252,7.583,7.583,0,0,0,59.779,7.677Zm-13.44,0A5.866,5.866,0,1,1,52.2,13.542,5.872,5.872,0,0,1,46.338,7.677Z",
    transform: "translate(-30.229 -0.102)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M49.911,48.179a.854.854,0,1,0-1.709,0,8.583,8.583,0,0,1-3.971,7.232c-.012.007-.023.014-.035.021a8.49,8.49,0,0,1-1.083.579.855.855,0,0,0,.348,1.636.844.844,0,0,0,.346-.074c.289-.128.566-.273.838-.425a10.225,10.225,0,0,1,4.275,4.681.855.855,0,0,0,1.559-.7,11.94,11.94,0,0,0-4.293-5.037A10.29,10.29,0,0,0,49.911,48.179Z",
    transform: "translate(-28.903 -31.046)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M3.327,43.927a.853.853,0,0,0,1.146-.383,10.277,10.277,0,0,1,4.093-4.308,10.265,10.265,0,0,0,2.426.976.843.843,0,0,0,.216.028.855.855,0,0,0,.214-1.682A8.57,8.57,0,0,1,13.568,21.7l1.762.033h.016a.855.855,0,0,0,.016-1.709l-1.778-.033A10.275,10.275,0,0,0,7.031,38.177a12.01,12.01,0,0,0-4.086,4.6A.854.854,0,0,0,3.327,43.927Z",
    transform: "translate(-2.854 -13.132)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M24.788,54.775a5.051,5.051,0,0,0,2.99.986,4.885,4.885,0,0,0,2.89-.963.854.854,0,1,0-1-1.389,3.244,3.244,0,0,1-3.832.019.855.855,0,0,0-1.052,1.347Z",
    transform: "translate(-17.013 -34.928)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M25.544,41.948a1.019,1.019,0,1,0-1.019,1.02A1.021,1.021,0,0,0,25.544,41.948Z",
    transform: "translate(-16.387 -26.855)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M38.544,41.948a1.02,1.02,0,1,0,1.02-1.02A1.021,1.021,0,0,0,38.544,41.948Z",
    transform: "translate(-26.242 -26.855)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEscogerLogo);
export default __webpack_public_path__ + "static/media/Escoger_logo.1cc8124ee4468b188530048d61ce5f78.svg";
export { ForwardRef as ReactComponent };